import { Store } from "bernie-plugin-mobx";
import { SerializedData } from "bernie-core";
import { Logger } from "bernie-logger";
import SherpaStore, { AppIds } from "./SherpaStore";

export default class ClientSherpaStore extends Store implements SherpaStore {
  public appIds: AppIds;
  public constructor(state: SerializedData, logger: Logger) {
    /* istanbul ignore next */
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    this.appIds = data.appIds;
  }
}
